import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomAPIResponse, CustomErrorType } from '@ld.consumer-portal/models';
import { CustomErrorModalService } from './custom-error-modal.service';
import { customErrorList } from './custom-errors';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandlerService {
  private readonly router = inject(Router);
  private readonly modalService = inject(CustomErrorModalService);

  isCustomError(requestUrl: string, customError: CustomAPIResponse | null | undefined): boolean {
    if (!customError?.resultCode) {
      return false;
    }

    try {
      const matchingError = customErrorList.find(
        (x) => x.resultCode === customError.resultCode && (x.url === null || requestUrl.includes(x.url))
      );
      return !!matchingError;
    } catch {
      return false;
    }
  }

  getCustomErrorObj(resultCode: string | null | undefined): CustomErrorType | undefined {
    if (!resultCode) {
      return undefined;
    }

    try {
      return customErrorList.find((x) => x.resultCode === resultCode);
    } catch {
      return undefined;
    }
  }

  getCustomErrorByCodeAndUrl(resultCode: string, requestUrl: string): CustomErrorType | undefined {
    if (!resultCode) {
      return undefined;
    }

    try {
      return customErrorList.find((x) => x.resultCode === resultCode && (x.url === null || requestUrl.includes(x.url)));
    } catch {
      return undefined;
    }
  }

  handleCustomError(customError: CustomErrorType): void {
    if (!customError) {
      return;
    }

    this.modalService.show(customError);
  }

  extractCustomApiResponse(error: unknown): CustomAPIResponse | null {
    if (!error || typeof error !== 'object') {
      return null;
    }

    const httpError = error as { error?: CustomAPIResponse };
    if (httpError.error?.resultCode) {
      return httpError.error;
    }

    return null;
  }

  processHttpError(requestUrl: string, error: unknown): boolean {
    const customApiResponse = this.extractCustomApiResponse(error);

    if (!customApiResponse || !this.isCustomError(requestUrl, customApiResponse)) {
      return false;
    }

    const customError = this.getCustomErrorObj(customApiResponse.resultCode);
    if (customError) {
      this.handleCustomError(customError);
      return true;
    }

    return false;
  }
}
